var impressum = "Impressum";
var privacy = "Integritet & juridisk information";
var recallInfo = "Information om återkallelse";
var signOut = "Logga ut";
var sv_se = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { sv_se as default, impressum, privacy, recallInfo, signOut };
